/** Stroke width of the prototype's line icons. */
export const ASK_NEXUS_ICON_STROKE = 1.75;

/** The expanded panel's column: as wide as the panel on most screens, still readable on very wide ones. */
const WIDE_COLUMN_CLASS = "max-w-[960px]";

/**
 * The thread, the composer, History and the first screen share one centred
 * column, so Expand widens all of them together.
 */
export function askNexusColumnClass(isWide: boolean, narrowClass = "max-w-[720px]"): string {
  return isWide ? WIDE_COLUMN_CLASS : narrowClass;
}
